import { cn } from '@eliadmin/core/src/utils/style-utils';
import React from 'react';

interface CustomHeadingProps {
  heading: string;
  className?: string;
  as?: 'h1' | 'h2' | 'h3';
}

const CustomHeading = ({ heading, className, as: Heading = 'h2' }: CustomHeadingProps) => {
  return (
    <Heading
      className={cn(
        'inline-block bg-gradient-to-b from-[#0C9685] to-[#12EAA6] bg-clip-text font-bold text-transparent',
        className,
      )}
    >
      {heading}
    </Heading>
  );
};

export default CustomHeading;
